// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`WelcomeNextShipment general snapshot 1`] = `
<div data-mr-ass="your-subscription" class="next-sub-shipment">
  <sectiontitle-stub text="Your subscription" data-mr-ass="also-in-box-next-order" class="text-center"></sectiontitle-stub>
  <invoicestatusbar-stub status="preparing"></invoicestatusbar-stub>
  <div class="next-sub">
    <div class="row next-date md-hide lg-hide">
      <div class="xs-12 xs-f-xsmall lg-f-small max-at-tweak upper upper color-slate">next shipment&nbsp;</div>
      <div class="xs-12 xs-f-medium lg-f-xmedium max-at-tweak bold"></div>
    </div>
    <invoicewithactionslayout-stub></invoicewithactionslayout-stub>
  </div>
</div>
`;
